(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* mobile menu */
  var btn = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (btn && nav) {
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* collapse header search on scroll */
  function onScroll() { document.body.classList.toggle('scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* tabs */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.tab') : null;
    if (!t) return;
    var root = t.closest('[data-tabs]');
    if (!root) return;
    root.querySelectorAll('.tab').forEach(function (x) { x.classList.toggle('is-active', x === t); });
    root.querySelectorAll('.panel').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === t.getAttribute('data-tab')); });
  });

  /* hero slider */
  function initHero(h) {
    if (h.getAttribute('data-ready')) return;
    h.setAttribute('data-ready', '1');
    var slides = h.querySelectorAll('.hero__slide');
    var dots = h.querySelectorAll('.hero__dots button');
    var pause = h.querySelector('[data-hero-pause]');
    if (slides.length < 2) return;
    var i = 0, timer = null, paused = reduce;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function play() { clearInterval(timer); if (!paused) timer = setInterval(function () { go(i + 1); }, 5500); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    if (pause) {
      if (paused) { pause.innerHTML = '&#9654;'; pause.setAttribute('aria-pressed', 'true'); }
      pause.addEventListener('click', function () {
        paused = !paused;
        pause.innerHTML = paused ? '&#9654;' : '&#10074;&#10074;';
        pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
        play();
      });
    }
    play();
  }
  function initAllHeroes(root) { (root || document).querySelectorAll('[data-hero]').forEach(initHero); }
  initAllHeroes(document);

  /* image banner slider */
  function initIb(b) {
    if (b.getAttribute('data-ready')) return;
    b.setAttribute('data-ready', '1');
    var items = b.querySelectorAll('.ib__item');
    var dots = b.querySelectorAll('.ib__dots button');
    if (items.length < 2) return;
    var i = 0, timer = null;
    function go(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function play() { clearInterval(timer); if (!reduce) timer = setInterval(function () { go(i + 1); }, 4500); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    play();
  }
  function initAllIb(root) { (root || document).querySelectorAll('[data-ib]').forEach(initIb); }
  initAllIb(document);

  /* scroll reveal */
  var SELECTOR = '.card, .tile, .stat, .feature, .edition, .promo, .faq details, .block__title';
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  }
  function setup(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el, k) {
      if (el.classList.contains('reveal')) return;
      el.classList.add('reveal');
      el.style.setProperty('--d', ((k % 6) * 0.07) + 's');
      if (io) io.observe(el); else el.classList.add('in');
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); initAllHeroes(e.target); initAllIb(e.target); });
})();
(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;

  /* read more */
  var desc = root.querySelector('[data-desc]');
  var more = root.querySelector('[data-desc-toggle]');
  if (desc && more) {
    if (desc.scrollHeight > desc.clientHeight + 12) {
      more.hidden = false;
      more.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        more.textContent = open ? 'Show less' : 'Read more';
      });
    } else { desc.classList.add('is-open'); }
  }

  var jsonEl = root.querySelector('[data-product-json]');
  var form = root.querySelector('form[action*="/cart/add"]');
  if (!jsonEl || !form) return;
  var variants = [];
  try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}

  /* quantity stepper */
  var qty = form.querySelector('input[name="quantity"]');
  var minus = form.querySelector('[data-qty-minus]');
  var plus = form.querySelector('[data-qty-plus]');
  if (qty && minus && plus) {
    minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
  }

  /* variant pills */
  var idInput = form.querySelector('[data-variant-id]');
  var atc = form.querySelector('.atc');
  var sticky = document.querySelector('[data-sticky-atc]');
  var stickyBtn = sticky ? sticky.querySelector('button') : null;
  var stickyPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');
  var opts = form.querySelectorAll('.opt');

  var buyNow = form.querySelector('[data-buynow]');
  function setBtn(label, disabled) {
    [atc, stickyBtn].forEach(function (b) { if (b) { b.textContent = label; b.disabled = disabled; } });
    if (buyNow) buyNow.disabled = disabled;
  }
  function update() {
    var sel = Array.prototype.map.call(opts, function (o) {
      var c = o.querySelector('input:checked');
      return c ? c.value : null;
    });
    opts.forEach(function (o, i) {
      var l = o.querySelector('[data-opt-val]');
      if (l && sel[i]) l.textContent = sel[i];
    });
    var v = variants.filter(function (x) {
      return sel.every(function (s, i) { return x.o[i] === s; });
    })[0];
    if (!v) { setBtn('Unavailable', true); return; }
    idInput.value = v.id;
    if (priceEl) priceEl.textContent = v.p;
    if (stickyPrice) stickyPrice.textContent = v.p;
    if (compareEl) { compareEl.textContent = v.c; compareEl.hidden = !v.c; }
    setBtn(v.a ? 'Add to cart' : 'Sold out', !v.a);
    if (window.history && history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
  }
  if (opts.length) form.addEventListener('change', function (e) { if (e.target.type === 'radio') update(); });

  /* sticky add-to-cart bar */
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(atc);
  }
})();
(function () {
  var drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;
  var lastFocus = null;
  function tab(name) {
    drawer.querySelectorAll('[data-dtab]').forEach(function (b) {
      var on = b.getAttribute('data-dtab') === name;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    drawer.querySelectorAll('[data-dpanel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-dpanel') === name);
    });
    var body = drawer.querySelector('.drawer__body');
    if (body) body.scrollTop = 0;
  }
  function open(name) {
    lastFocus = document.activeElement;
    tab(name || 'menu');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    document.querySelectorAll('.burger').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var c = drawer.querySelector('.drawer__close');
    if (c) c.focus();
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    document.querySelectorAll('.burger').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest ? e.target.closest('[data-open-drawer]') : null;
    if (o) { e.preventDefault(); open(o.getAttribute('data-open-drawer')); return; }
    if (e.target.closest('[data-drawer-close]')) { close(); return; }
    var t = e.target.closest('[data-dtab]');
    if (t && drawer.contains(t)) tab(t.getAttribute('data-dtab'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();

/* product press animation */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clearPressed() {
    document.querySelectorAll('.card.is-pressed').forEach(function (c) { c.classList.remove('is-pressed'); });
  }
  document.addEventListener('pointerdown', function (e) {
    var c = e.target.closest ? e.target.closest('.card') : null;
    if (!c || e.target.closest('.card__add') || e.target.closest('.wish')) return;
    c.classList.add('is-pressed');
  });
  ['pointerup', 'pointercancel', 'touchmove', 'dragstart'].forEach(function (ev) {
    document.addEventListener(ev, clearPressed, { passive: true });
  });
  window.addEventListener('scroll', clearPressed, { passive: true });
  /* click sound effect (product cards) */
  var clickSrc = (document.querySelector('[data-click-sound]') || {}).getAttribute ? document.querySelector('[data-click-sound]').getAttribute('data-click-sound') : '';
  var clickAudio = null;
  function warmSound() {
    if (clickAudio || !clickSrc) return;
    try { clickAudio = new Audio(clickSrc); clickAudio.preload = 'auto'; clickAudio.volume = 0.9; clickAudio.load(); } catch (err) {}
  }
  function playClick() {
    warmSound();
    if (!clickAudio) return;
    try { clickAudio.currentTime = 0; var p = clickAudio.play(); if (p && p.catch) p.catch(function () {}); } catch (err) {}
  }
  ['pointerdown', 'touchstart', 'mouseover'].forEach(function (n) { document.addEventListener(n, warmSound, { once: true, passive: true }); });

  document.addEventListener('click', function (e) {
    var hit = e.target.closest ? e.target.closest('.card') : null;
    if (hit && !e.target.closest('.card__add') && !e.target.closest('.wish') && e.target.closest('a')) playClick();
    if (reduce || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a') : null;
    if (!a || !a.href || a.target === '_blank') return;
    var card = a.closest('.card');
    if (!card) return;
    e.preventDefault();
    card.classList.remove('is-pressed');
    card.classList.add('is-tapped');
    setTimeout(function () { window.location.href = a.href; }, 320);
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.card.is-tapped').forEach(function (c) { c.classList.remove('is-tapped'); });
  });
})();

/* dark / light toggle */
(function () {
  var btns = document.querySelectorAll('[data-theme-toggle]');
  if (!btns.length) return;
  var root = document.documentElement;
  function cur() { return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'; }
  function sync() {
    var dark = cur() === 'dark';
    btns.forEach(function (b) {
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
      b.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
    });
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', getComputedStyle(root).getPropertyValue('--bg').trim());
  }
  sync();
  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var next = cur() === 'dark' ? 'light' : 'dark';
      root.classList.add('theme-anim');
      root.setAttribute('data-theme', next);
      try { localStorage.setItem('mm-theme', next); } catch (e) {}
      b.classList.add('spin');
      sync();
      setTimeout(function () { root.classList.remove('theme-anim'); b.classList.remove('spin'); }, 450);
    });
  });
})();

/* wishlist (saved in this browser) */
(function () {
  var KEY = 'mm-wish';
  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function paint() {
    var list = read();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
    document.querySelectorAll('[data-wish-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = !list.length;
    });
  }
  window.mmWishPaint = paint;

  var page = document.querySelector('[data-wishlist-page]');
  var grid = page ? page.querySelector('[data-wish-grid]') : null;
  var empty = page ? page.querySelector('[data-wish-empty]') : null;
  var clearBtn = page ? page.querySelector('[data-wish-clear]') : null;
  function syncEmpty() {
    if (!page) return;
    var has = grid.children.length > 0;
    empty.hidden = has;
    clearBtn.hidden = !has;
  }
  function render() {
    if (!page) return;
    var list = read().slice().reverse();
    grid.innerHTML = '';
    if (!list.length) { syncEmpty(); return; }
    Promise.all(list.map(function (h) {
      return fetch(page.getAttribute('data-base') + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) { return { h: h, html: html }; })
        .catch(function () { return { h: h, html: '' }; });
    })).then(function (res) {
      var gone = [];
      res.forEach(function (x) {
        if (x.html === null) { gone.push(x.h); return; }
        if (!x.html.trim()) return;
        var d = document.createElement('div');
        d.innerHTML = x.html;
        var card = d.querySelector('.card');
        if (card) grid.appendChild(card);
      });
      if (gone.length) write(read().filter(function (h) { return gone.indexOf(h) < 0; }));
      paint();
      syncEmpty();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-wish]') : null;
    if (b) {
      e.preventDefault();
      var h = b.getAttribute('data-wish');
      var list = read();
      var i = list.indexOf(h);
      if (i > -1) {
        list.splice(i, 1);
        var card = page ? b.closest('.card') : null;
        if (card && grid.contains(card)) card.parentNode.removeChild(card);
      } else { list.push(h); }
      write(list);
      paint();
      syncEmpty();
      return;
    }
    if (clearBtn && e.target.closest('[data-wish-clear]')) {
      write([]);
      grid.innerHTML = '';
      paint();
      syncEmpty();
    }
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { paint(); render(); } });
  paint();
  render();
})();

/* related products (upgrade to Shopify recommendations) */
(function () {
  var box = document.querySelector('[data-related]');
  if (!box || !window.fetch || !window.DOMParser) return;
  fetch(box.getAttribute('data-url'))
    .then(function (r) { return r.ok ? r.text() : ''; })
    .then(function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var g = doc.querySelector('.grid');
      var cur = box.querySelector('[data-related-grid]');
      if (g && cur && g.querySelector('.card')) {
        cur.innerHTML = g.innerHTML;
        box.hidden = false;
        if (window.mmWishPaint) window.mmWishPaint();
      }
    })
    .catch(function () {});
})();

/* collection filter and sort */
(function () {
  var form = document.querySelector('[data-filter-form]');
  if (!form) return;
  var toggle = form.querySelector('[data-filter-toggle]');
  var panel = form.querySelector('[data-filter-panel]');
  var sort = form.querySelector('[data-sort-select]');
  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (panel.querySelector('input:checked')) { panel.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); }
  }
  if (sort) sort.addEventListener('change', function () { form.submit(); });
  form.addEventListener('submit', function () {
    form.querySelectorAll('input[type=number]').forEach(function (i) { if (i.value === '') i.disabled = true; });
  });
})();

/* menu button (three lines) sound effect */
(function () {
  var src = document.body ? document.body.getAttribute('data-menu-sound') : '';
  if (!src) return;
  var audio = null;
  function warm() {
    if (audio) return;
    try { audio = new Audio(src); audio.preload = 'auto'; audio.volume = 0.9; audio.load(); } catch (err) {}
  }
  ['pointerdown', 'touchstart', 'mouseover'].forEach(function (n) { document.addEventListener(n, warm, { once: true, passive: true }); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.burger') : null;
    if (!b) return;
    warm();
    if (!audio) return;
    try { audio.currentTime = 0; var p = audio.play(); if (p && p.catch) p.catch(function () {}); } catch (err) {}
  });
})();

/* ===== v20: add-to-cart without leaving the page (toast + cart count bump) ===== */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var toast = null, timer = null;
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function show(html, isErr) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    toast.classList.toggle('is-error', !!isErr);
    toast.classList.add('is-show');
    clearTimeout(timer);
    timer = setTimeout(function () { toast.classList.remove('is-show'); }, 3400);
  }
  function setCount(n) {
    document.querySelectorAll('.cart-link b').forEach(function (b) { b.textContent = n; });
    document.querySelectorAll('.bnav a[href*="/cart"]').forEach(function (a) {
      var b = a.querySelector('.bnav__count');
      if (!b) { b = document.createElement('b'); b.className = 'bnav__count'; a.appendChild(b); }
      b.textContent = n; b.hidden = n < 1;
    });
    document.querySelectorAll('.cart-link, .bnav a[href*="/cart"]').forEach(function (a) {
      a.classList.remove('bump'); void a.offsetWidth; a.classList.add('bump');
    });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var sub = e.submitter;
    if (sub && (sub.name === 'checkout' || sub.hasAttribute('data-buynow'))) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    var btns = [sub || form.querySelector('[type="submit"]')];
    var sticky = document.querySelector('[data-sticky-atc] button');
    if (sticky && form.id === 'product-form') btns.push(sticky);
    btns = btns.filter(Boolean);
    var labels = btns.map(function (b) { return b.innerHTML; });
    form.classList.add('is-busy');
    var fd = new FormData(form);
    fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        form.classList.remove('is-busy');
        if (!res.ok) { show('<div><b>Could not add</b><span>' + esc(res.j.description || res.j.message || 'Please try again') + '</span></div>', true); return; }
        var item = res.j;
        btns.forEach(function (b) { b.classList.add('is-added'); if (b.classList.contains('atc') || b.closest('[data-sticky-atc]')) b.textContent = 'Added \u2713'; });
        setTimeout(function () { btns.forEach(function (b, i) { b.classList.remove('is-added'); b.innerHTML = labels[i]; }); }, 1500);
        var img = item.image ? '<img src="' + esc(item.image) + '" alt="">' : '';
        show(img + '<div><b>Added to cart</b><span>' + esc(item.product_title) + '</span></div><a href="' + root + 'cart">View cart</a>');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      })
      .catch(function () { form.classList.remove('is-busy'); HTMLFormElement.prototype.submit.call(form); });
  });
})();

/* ===== v20: image skeleton (marks containers once their image has loaded) ===== */
(function () {
  var SEL = '.card__img, .pm__item, .dcat__img';
  function mark(c) { c.classList.add('is-loaded'); }
  function check(c) { var img = c.querySelector('img'); if (!img || img.complete) mark(c); }
  function scan(r) { (r || document).querySelectorAll(SEL).forEach(function (c) { if (!c.classList.contains('is-loaded')) check(c); }); }
  scan(document);
  function onImg(e) { var t = e.target; if (t && t.tagName === 'IMG' && t.closest) { var c = t.closest(SEL); if (c) mark(c); } }
  document.addEventListener('load', onImg, true);
  document.addEventListener('error', onImg, true);
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches(SEL)) check(n); scan(n); } }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ===== v20: product gallery (swipe, dots, thumbnails, counter) ===== */
(function () {
  var pm = document.querySelector('[data-pm]');
  if (!pm) return;
  var wrap = pm.parentNode;
  var items = pm.querySelectorAll('.pm__item');
  var dots = wrap.querySelectorAll('[data-pm-dots] button');
  var thumbs = wrap.querySelectorAll('[data-pm-thumbs] button');
  var count = wrap.querySelector('[data-pm-count]');
  function set(i) {
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    thumbs.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    if (count) count.textContent = (i + 1) + ' / ' + items.length;
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) set(Array.prototype.indexOf.call(items, e.target)); });
    }, { root: pm, threshold: 0.6 });
    items.forEach(function (it) { io.observe(it); });
  }
  wrap.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-pm-go]') : null;
    if (!b) return;
    var i = parseInt(b.getAttribute('data-pm-go'), 10);
    if (items[i] && items[i].scrollIntoView) items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
})();

/* ===== v20: countdown ===== */
(function () {
  document.querySelectorAll('[data-countdown]').forEach(function (box) {
    var raw = (box.getAttribute('data-end') || '').trim().replace(' ', 'T');
    var end = new Date(raw).getTime();
    var units = box.querySelector('.cd__units');
    var ended = box.querySelector('[data-cd-ended]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function put(k, v) { var el = box.querySelector('[data-cd="' + k + '"]'); if (el) el.textContent = pad(v); }
    var iv;
    function tick() {
      var left = end - Date.now();
      if (isNaN(end) || left <= 0) {
        if (units) units.hidden = true;
        if (ended) ended.hidden = false;
        clearInterval(iv);
        return;
      }
      var s = Math.floor(left / 1000);
      put('d', Math.floor(s / 86400)); put('h', Math.floor(s % 86400 / 3600));
      put('m', Math.floor(s % 3600 / 60)); put('s', s % 60);
    }
    tick();
    iv = setInterval(tick, 1000);
  });
})();

/* ===== v20: scroll progress bar + back to top ===== */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bar = document.createElement('div');
  bar.className = 'scroll-progress';
  document.body.appendChild(bar);
  var top = document.createElement('button');
  top.type = 'button';
  top.className = 'to-top';
  top.setAttribute('aria-label', 'Back to top');
  top.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
  document.body.appendChild(top);
  var ticking = false;
  function upd() {
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
    bar.style.transform = 'scaleX(' + p + ')';
    top.classList.toggle('is-show', window.scrollY > 600);
    ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
  upd();
  top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
})();
